import BaseModel from "./BaseModel";

class OrganizationModel extends BaseModel {
  id: number | null = null;
  name: string = "";
  description: string = "";
  amount: number = 0;
  date: string = "";

  constructor(options?: any) {
    super(options);
    this.setData(options);
  }
}

export default OrganizationModel;
